import type { AssetInfoAssetTypeProps } from "./asset-info-asset-type.type";

import { useTranslation } from "react-i18next";

import { useGetAssetType } from "@/entities/asset-type";
import { FlexContainerText } from "@/modules/flex-container";

export const AssetInfoAssetType = ({
  asset_type_id,
}: AssetInfoAssetTypeProps) => {
  const { t } = useTranslation();

  const { assetType, isLoading: assetTypeIsLoading } =
    useGetAssetType(asset_type_id);

  return (
    <FlexContainerText
      value={assetType?.name}
      label={t("asset:form.assetType.label")}
      isLoading={assetTypeIsLoading}
    />
  );
};
